import React from "react";

import ControlLogsPage from "pages/control/ControlLogsPage";
import ViewLogPage from "pages/dashboard/ViewLogPage";
import { useMissionOverviewRange } from "providers/MissionOverviewRangeProvider";

const FleetMissionLogsRoute = () => {
    const { rangeSettings, setRangeSettings } = useMissionOverviewRange();
    return (
        <ControlLogsPage
            fleetMode
            rangeSettings={rangeSettings}
            onRangeSettingsChange={setRangeSettings}
        />
    );
};

export const logRoutes = {
    path: "log",
    children: [
        {
            path: "mission",
            element: <FleetMissionLogsRoute />,
        },
        {
            path: "background",
            element: <div>background</div>,
        },
        {
            path: "detail/:type/:arc/:logID",
            element: <ViewLogPage />,
            loader: ({ params }) => {
                return {
                    type: params.type,
                    arc: params.arc,
                    logID: params.logID,
                };
            },
        },
    ],
};
